const HeroHeading = () => {
  return (
    <div className="text-black dark:text-white text-left px-4 pb-9 sm:pr-16 sm:pb-0 flex flex-row gap-6 relative mb-0 max-w-[1260px] mx-auto">
      <div className="space-y-3 my-auto">
        <p className="text-2xl md:text-5xl font-medium leading-tight lg:leading-[60px]">
          Welcome to Bot Builder
        </p>
        <p className="text-sm lg:text-xl font-normal md:w-[740px] mb-6 lg:mb-0">
          The ultimate platform to create intelligent and customizable bots.
          Whether you&apos;re streamlining workflows, boosting customer
          engagement, or offering 24/7 support, this tool has everything you
          need to build smarter and faster.
        </p>
      </div>

      <div className="sm:block hidden">
        <img
          src="/bot.png"
          alt="bot-img"
          className="w-[360px] object-contain"
        />
      </div>
    </div>
  );
};

export default HeroHeading;
